exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"RemindPassword.scss?vue&type=style&index=0&id=fd28b002&lang=scss&scoped=true&","sourceRoot":""}]);

// exports
